// extracted by mini-css-extract-plugin
export default {"departments":"HH-z","departmentHeading":"IH-z","departmentSection":"JH-z","departmentName":"KH-z","departmentLink":"LH-z","expandIcon":"MH-z"};